import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

type DateInput = { year: string; month: string; day: string };

type DateFormat = "YYYY-MM-DD" | "MM-DD-YYYY" | "DD-MM-YYYY";

/** Convert formatted date to input date.
 * @param {DateInput} dateInput
 * @param {string} outputFormat
 */
function getFormattedFromDateInput(dateInput: DateInput, outputFormat: DateFormat): string {
   return dayjs(`${dateInput.year}-${dateInput.month}-${dateInput.day}`).format(outputFormat);
}

function getDateInputFromFormatted(dateFormatted: string, inputFormat: DateFormat): DateInput {
   const dateObject = dayjs(dateFormatted, inputFormat);
   return {
      year: dateObject.get("year").toString(),
      month: `${dateObject.get("month") + 1}`, // Months [only] are zero indexed (gah, js), so January is month 0.
      day: dateObject.get("date").toString(),
   };
}

/** Check if the date is real to prevent invalid dates like 31st Feb or 31st of Sep.
 * @param {string} day
 * @param {string} month
 * @param {string} year
 */
function isDateReal(day, month, year) {
   const allInputsPresent = day && month && year;
   const allInputsAreNumbers = !isNaN(Number(day)) && !isNaN(Number(month)) && !isNaN(Number(year));

   // if all inputs are present and are numbers, we can try to parse the date
   if (allInputsPresent && allInputsAreNumbers) {
      const parsedDate = dayjs(`${year}-${month}-${day}`, "YYYY-M-D");

      // dayjs will return a valid date even if the input is invalid
      // for example 31st Feb will be converted to 3rd March
      // so we need to check if the parsed date is the same as the input
      return (
         parsedDate.isValid() &&
         parsedDate.date() === Number(day) &&
         parsedDate.month() + 1 === Number(month) &&
         parsedDate.year() === Number(year)
      );
   } else {
      // if any of the inputs are empty or not numbers, we can't validate the date and should return true
      return true;
   }
}

export { getFormattedFromDateInput, getDateInputFromFormatted, isDateReal };
